(() => {
  const previewSessionId = new URLSearchParams(window.location.search).get('oseid');
  if (!previewSessionId) return;

  const previewProductPath = /^\/products\/(?:utsuwa-naire(?:-repeat)?|ori-naire(?:-repeat)?)\/?$/;

  const preservePreviewSession = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || !previewProductPath.test(url.pathname)) return;
      url.searchParams.set('oseid', previewSessionId);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => preservePreviewSession(), { once: true });
  } else {
    preservePreviewSession();
  }

  document.addEventListener('shopify:section:load', (event) => preservePreviewSession(event.target));
})();
